let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("5uoHm"), load("6Uw9p")]).then(() => parcelRequire('icgY0'));